module.exports = __webpack_public_path__ + "static/media/0019.39ddd580.png";